import styled from 'styled-components';

export const ActivityTabsStyled = styled.div`
  width: calc(100% - 40px);
  margin: 0 auto;
  border-bottom: 1px solid ${(p) => p.theme.colors.grey.input};
  display: flex;
  align-items: center;
`;
